import { render, staticRenderFns } from "./hotelsXq.vue?vue&type=template&id=3a50d3ef&scoped=true&"
import script from "./hotelsXq.vue?vue&type=script&lang=js&"
export * from "./hotelsXq.vue?vue&type=script&lang=js&"
import style0 from "./hotelsXq.vue?vue&type=style&index=0&id=3a50d3ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50d3ef",
  null
  
)

export default component.exports